import { isLoggedIn } from './../../../../../core/auth/_selectors/auth.selectors';
import { Permission } from './../../../../../core/auth/_models/permission.model';
import { User } from "./../../../../../core/auth/_models/user.model";
import { Credentials } from "./../../../../../core/auth/_models/credentials";
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable, Subject, of, throwError } from "rxjs";
import { Router, RouterStateSnapshot, ActivatedRoute } from "@angular/router";
import './../../../shared/extension-method';
import {
  AuthService,
  AuthNoticeService,
  Login,
  UserLoaded,
  AllPermissionsLoaded
} from "../../../../../core/auth";
import { TranslateService } from "@ngx-translate/core";
import { Store, select } from "@ngrx/store";
import { AppState } from "../../../../../core/reducers";
import { tap, takeUntil, finalize, map, catchError } from "rxjs/operators";
import { RoleService } from '../../../shared/services/roleService';
import { SharedObject } from '../../../shared/sharedObject';

@Component({
  selector: "kt-login",
  templateUrl: "./login.component.html",
  styleUrls: ['login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  loading = false;
  isLoggedIn$: Observable<boolean>;
  errors: any = [];
  private unsubscribe: Subject<any>;

  /**
   * Component constructor
   *
   * @param router: Router
   * @param auth: AuthService
   * @param authNoticeService: AuthNoticeService
   * @param translate: TranslateService
   * @param store: Store<AppState>
   * @param fb: FormBuilder
   * @param cdr
   */
  constructor(
    private router: Router,
    private auth: AuthService,
    private authNoticeService: AuthNoticeService,
    private translate: TranslateService,
    private store: Store<AppState>,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private roleService: RoleService,
    private aRoute: ActivatedRoute

  ) {
    this.store
      .pipe(
        select(isLoggedIn),
        tap(loggedIn => {
          if (loggedIn) {
            this.router.navigateByUrl('/account/dashboard');
          }
        })).subscribe();

    this.unsubscribe = new Subject();
  }
  ngOnInit(): void {
    this.initLoginForm();

  }

  ngOnDestroy(): void {
    this.authNoticeService.setNotice(null);
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.loading = false;
  }

  initLoginForm() {
    this.loginForm = this.fb.group({
      mobileNumber: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.pattern(SharedObject.MobilePattern)
        ])
      ],
      password: [
        "",
        Validators.compose([
          Validators.required
        ])
      ]
    });
  }


  submit() {
    const controls = this.loginForm.controls;
    /** check form */
    if (this.loginForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.loading = true;
    const authData = {
      mobile: controls["mobileNumber"].value.FaToEnDigits(),
      password: controls["password"].value.FaToEnDigits()
    };
    this.auth
      .login(authData.mobile, authData.password)
      .pipe(
        tap(res => {
          if (res) {
            const returnUser: User = new User();
            returnUser.firstName = res["result"]["firstName"];
            returnUser.lastName = res["result"]["lastName"];
            returnUser.isMale = res["result"]["isMale"];
            returnUser.username =controls["mobileNumber"].value.FaToEnDigits();
            returnUser.access_token = res["result"]["access_token"];
            returnUser.refresh_token = res["result"]["refresh_token"];
            returnUser.userStatus = res["result"]["userStatus"];
            returnUser.role = res["result"]["role"];
            this.store.dispatch(
              new Login({ authToken: returnUser.access_token })
            );
            this.store.dispatch(new UserLoaded({ user: returnUser }));
            this.roleService.getAllRoles();
            let params = this.aRoute.snapshot.queryParams;
            if (params['redirectURL']) {
              let redirectURL = params['redirectURL'] as string;
              if (redirectURL) {
                this.router.navigateByUrl(redirectURL);
              }

            } else
              this.router.navigateByUrl("/account/dashboard"); // Main page
          } else {
            this.loading = false;
            this.authNoticeService.setNotice("کاربر با این مشخصات یافت نشد", "danger");
          }
        }),
        catchError(err => {
          this.loading = false;
          var error = "خطای سرور";
          if (err.error.result) error = err.error.result;
          this.authNoticeService.setNotice(error, "danger");
          this.cdr.detectChanges();
          return of([]);
        }),
        takeUntil(this.unsubscribe),
        finalize(() => {

          this.cdr.detectChanges();
        })
      )
      .subscribe();
  }

  /**
   * Checking control validation
   *
   * @param controlName: string => Equals to formControlName
   * @param validationType: string => Equals to valitors name
   */
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.loginForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result =
      control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  goToRegister() {
    let params = this.aRoute.snapshot.queryParams;
    if (params['redirectURL']) {
      let redirectURL = params['redirectURL'];
      if (redirectURL) {
        this.router.navigate(['auth/register'], { queryParams: { 'redirectURL': redirectURL } });
      }
    }
    else
      this.router.navigateByUrl("auth/register");
  }
}
